import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import useLenis from "@/hooks/useLenis";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import About from "@/pages/About";
import IndianAlchemy from "@/pages/IndianAlchemy";
import PlatinumHospitality from "@/pages/PlatinumHospitality";
import Portfolio from "@/pages/Portfolio";
import Consultation from "@/pages/Consultation";
import Contact from "@/pages/Contact";
import Deposit from "@/pages/Deposit";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

function Shell() {
  useLenis();
  const { pathname } = useLocation();
  const hideChrome = pathname === "/deposit";

  return (
    <div className="relative bg-[#FDFBF6] text-[#3B1F1A]">
      <ScrollToTop />
      {!hideChrome && <Nav />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/indian-alchemy" element={<IndianAlchemy />} />
          <Route path="/platinum-hospitality" element={<PlatinumHospitality />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/book" element={<Consultation />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/deposit" element={<Deposit />} />
        </Routes>
      </main>
      {!hideChrome && <Footer />}
      {!hideChrome && <WhatsAppFloat />}
      <Toaster position="bottom-right" />
    </div>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}
